export default "__VITE_ASSET__C_Nmrc6i__"